import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ChangableComponent } from '@app/models/changable.component';
import { BillingApiAccountResponseDto, BillingApiMerchantResponseDto } from '@lingo2-billing-sdk/models';
import { isEqual } from 'lodash';
import { IBillingPaymentMethod } from '../payment-widget-billing/payment-widget-billing.service';

export enum BankCardType {
  mir = 'mir',
  american_express = 'american_express',
  visa = 'visa',
  mastercard = 'mastercard',
  master_card = 'master_card',
  maestro = 'maestro',
}

@Component({
  selector: 'app-payment-widget-payment-method-selector',
  templateUrl: './payment-widget-payment-method-selector.component.html',
  styleUrls: ['./payment-widget-payment-method-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentWidgetPaymentMethodSelectorComponent extends ChangableComponent {
  @Input() set paymentMethods(value: BillingApiAccountResponseDto[]) {
    if (value?.length && !isEqual(value, this._paymentMethods)) {
      this._paymentMethods = value;
      if (this._paymentMethods.length && this.defaultAccount) {
        this.onSelect(this.defaultAccount, 'account');
      }
    }
  }

  public get paymentMethods() {
    return this._paymentMethods;
  }

  @Input() set paymentProviders(data: BillingApiMerchantResponseDto[]) {
    if (data?.length && !isEqual(data, this._paymentProviders)) {
      this._paymentProviders = data;
    }
  }

  public get paymentProviders() {
    return this._paymentProviders;
  }

  @Input() set initAdd(value: boolean) {
    if (value) {
      this.selected = null;
      this.paymentMethodSelected.emit(null);
    } else {
      if (this._paymentMethods.length && this.defaultAccount) {
        this.onSelect(this.defaultAccount, 'account');
      }
    }
  }

  @Input() set selectedAccountId(accountId: string) {
    if (this._paymentMethods?.length) {
      this.defaultAccount = this._paymentMethods.find((account) => account.id === accountId);
      if (this.defaultAccount) {
        this.onSelect(this.defaultAccount, 'account');
      }
    }
  }

  @Output() paymentMethodSelected = new EventEmitter<IBillingPaymentMethod>();

  public selected: IBillingPaymentMethod = null;
  public defaultAccount: BillingApiAccountResponseDto = null;
  public _paymentProviders: BillingApiMerchantResponseDto[];
  public _paymentMethods: BillingApiAccountResponseDto[];

  /** Если выбран провайдер для нового способа оплаты или уже имеющийся счет */
  public onSelect(method: any, type: 'account' | 'provider'): void {
    if (type === 'account') {
      this.selected = {
        paymentMethod: method,
        provider: null,
      };
    } else if (type === 'provider') {
      this.selected = {
        paymentMethod: null,
        provider: method,
      };
    }
    this.paymentMethodSelected.emit(this.selected);
    this.markForCheck();
  }

  public isForNotRussia(merchant: BillingApiMerchantResponseDto) {
    if (merchant.unSupportCountries) {
      return (merchant.unSupportCountries as any[]).includes('RU');
    } else {
      if (merchant.supportedCountries) {
        return !(merchant.supportedCountries as any[]).includes('RU');
      } else {
        return true;
      }
    }
  }

  public trackByFn(index, item: BillingApiAccountResponseDto | BillingApiMerchantResponseDto) {
    return item.id;
  }

  public isTestCard(account: BillingApiAccountResponseDto) {
    return this.paymentProviders.find((provider) => provider.id === account.providerId).testMode;
  }
}
